import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getExpandedItems } from "../../utils/outbound-labels-utils";
import { ItemInfo, ItemNameCell } from "../cells/item-name-cell";

const catalogEntry = fgColumnEntries["item-name"];

export function ItemNameColumn({
  checkedSubItems,
  toggleSubItemSelection,
  groupsWaitingForSplit = [],
}: {
  checkedSubItems: Map<string, Set<number>>;
  toggleSubItemSelection: (rowId: string, subItemIndex: number) => void;
  groupsWaitingForSplit?: string[];
}): Column2<FulfillmentGroupData> {
  return {
    alignment: ColumnAlignment.LEFT,
    key: catalogEntry.key,
    title: catalogEntry.title,
    renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
      const isWaitingForSplit = groupsWaitingForSplit.includes(row._id);
      return (
        <ItemNameCell
          isWaitingForSplit={isWaitingForSplit}
          lineItems={getExpandedItems(row)}
        />
      );
    },
    width: catalogEntry.defaultWidth,
    sort: catalogEntry.sortDirection,
    hidden: true,
    renderExpandedCell: ({
      row,
      expansionIndex,
    }: {
      row: FulfillmentGroupData;
      expansionIndex: number;
    }) => {
      const lineItem = getExpandedItems(row)?.[expansionIndex];
      if (!lineItem) {
        return null;
      }
      const isWaitingForSplit = groupsWaitingForSplit.includes(row._id);
      const subItemSelections = checkedSubItems.get(row._id) || new Set();
      const isSubItemChecked = subItemSelections.has(expansionIndex);

      return (
        <Flex align="center" gap="sm" pl="lg">
          <div
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <RedoCheckbox
              disabled={isWaitingForSplit}
              onClick={() => {
                toggleSubItemSelection(row._id, expansionIndex);
              }}
              setValue={() => {}}
              size="sm"
              value={isSubItemChecked}
            />
          </div>
          <ItemInfo isWaitingForSplit={isWaitingForSplit} lineItem={lineItem} />
        </Flex>
      );
    },
  };
}
